import DownloadIcon from '@mui/icons-material/Download';
import { Button, Stack } from '@mui/material';
import PropTypes from 'prop-types';

// The row under the grid: Export CSV on the left; Clear filters and Discard changes on the right,
// kept away from Add Product and Save so changes aren't thrown away by a click meant for those.
// Fixed height so the grid doesn't jump when the conditional buttons appear.
const GridFooterActions = ({
  canExport,
  onExport,
  filteredColumnCount,
  onClearFilters,
  unsavedCount,
  onDiscard,
  disabled,
}) => (
  <Stack direction='row' spacing={2} justifyContent='space-between' sx={{ minHeight: 36 }}>
    <Button
      variant='outlined'
      startIcon={<DownloadIcon />}
      onClick={onExport}
      disabled={!canExport}
    >
      Export CSV
    </Button>
    <Stack direction='row' spacing={2}>
      {filteredColumnCount > 0 && (
        <Button variant='outlined' onClick={onClearFilters} disabled={disabled}>
          {`Clear filters (${filteredColumnCount})`}
        </Button>
      )}
      {unsavedCount > 0 && (
        <Button variant='outlined' color='error' onClick={onDiscard} disabled={disabled}>
          {`Discard changes (${unsavedCount})`}
        </Button>
      )}
    </Stack>
  </Stack>
);

GridFooterActions.propTypes = {
  canExport: PropTypes.bool.isRequired,
  onExport: PropTypes.func.isRequired,
  filteredColumnCount: PropTypes.number.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  unsavedCount: PropTypes.number.isRequired,
  onDiscard: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default GridFooterActions;
